import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

import { Redirect } from 'react-router-dom';
import { getTokenInfo } from '../../../UseToken';

import { /*object_type,*/ api_crud_base, api_list_route, api_crud_route, data_interface, endpoints } from './Config';

import 'react-phone-number-input/style.css'

import Hosts from '../../../Hosts';

import { confirmAlert } from 'react-confirm-alert';

//import FileUpload from '../FileUpload/FileUpload' ;

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	set_language,
	content_language, 
	check_interface,

} from '../../../Utils';

import { language } from '../../WEBContent/Language';


export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);
	//const [reviewers, set_reviewers] = useState([]);
	const [editores, set_editores] = useState([]);

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

	const [/*show_vat_form */, set_show_vat_form] = useState('');
	const [show_delete_button, set_show_delete_button] = useState('d-none');

	const [is_edit, set_is_edit] = useState(false)
	//console.log(is_edit)

	const [nome_convidado, set_nome_convidado] = useState('')
	const [area_convidado, set_area_convidado] = useState('')
	const [instituicao_convidado, set_instituicao_convidado] = useState('')
	const [descricao_convidado, set_descricao_convidado] = useState('')

	//const [topicos, set_topicos] = useState([])
	//const [nome_topico, set_nome_topico] = useState('')

	const [nome_cfp, set_nome_cfp] = useState('')
	const [descricao_cfp, set_descricao_cfp] = useState('')
	const [data_inicio_cfp, set_data_inicio_cfp] = useState('')
	const [data_submissao_cfp, set_data_submissao_cfp] = useState('')
	const [data_limite_fim_cfp, set_data_limite_fim_cfp] = useState('')
	const [data_material_suplementar_cfp, set_data_material_suplementar_cfp] = useState('')
	const [data_resposta_revisao_cfp, set_data_resposta_revisao_cfp] = useState('')
	const [data_limite_edicao_cfp, set_data_limite_edicao_cfp] = useState('')
	const [data_decisao_final_revisor_cfp, set_data_decisao_final_revisor_cfp] = useState('')
	const [data_final_processo_cfp, set_data_final_processo_cfp] = useState('')

	//const [topico_selected, set_selected_topico] = useState({label: '', value: ''})
	const [editor_selected, set_selected_editor] = useState({label: '', value: ''})

	const [avaliable_file, set_avaliable_file] = useState([])
	const [avaliable_lang, set_avaliable_lang] = useState([])

	const [questions_visibility_author_state, set_questions_visibility_author_state] = useState([])
	const [pergunta, set_pergunta] = useState('')

	//const [file_name, set_file_name] = useState([]);
	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);

	const [refresh, setRefresh] = useState(0);

	//const articles = useRef([]);

    //const reviewers = useRef([]);


	const custom_select_styles = {
		container: base => ({
			...base,
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "10px",
			padding: "2px 10px",
			fontSize: '14px'
		}),
	}

	//let newDate = new Date();
	//let today = newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, "0") + '-' + newDate.getDate().toString().padStart(2, "0");

	const change_tipo = e => {
		set_dados(dados.current.info.tipo = e.value);
		//set_dados(dados)
	}

	let compareDataWithInterface = (data, d_interface) => { 

		data.id = check_interface(data.id, d_interface.id)
		data.info = check_interface(data.info, d_interface.info)
		data.info.companycode = check_interface(data.info.companycode, d_interface.info.companycode)
		data.info.unique_code = check_interface(data.info.unique_code , d_interface.info.unique_code)
		data.info.name = check_interface(data.info.name , d_interface.info.name)
		data.info.tipo = check_interface(data.info.tipo , d_interface.info.tipo)
		data.info.description = check_interface(data.info.description , d_interface.info.description)

		data.info.cfp = check_interface(data.info.cfp , d_interface.info.cfp)


		//Não utilizado no call for paper para não criar logo um cfp vazio no registo de um evento
		/*data.info.cfp.forEach(v => { 

			v.id = check_interface(v.id, d_interface.info.cfp[0].id)
			v.nome = check_interface(v.nome, d_interface.info.cfp[0].nome)
			v.descricao = check_interface(v.descricao, d_interface.info.cfp[0].descricao)
			v.data_inicio = check_interface(v.data_inicio, d_interface.info.cfp[0].data_inicio)
			v.data_submissao = check_interface(v.data_submissao, d_interface.info.cfp[0].data_submissao)
			v.data_limite_fim = check_interface(v.data_limite_fim, d_interface.info.cfp[0].data_limite_fim)
			v.data_marerial_suplementar = check_interface(v.data_marerial_suplementar, d_interface.info.cfp[0].data_marerial_suplementar)
			v.data_resposta_revisao = check_interface(v.data_resposta_revisao, d_interface.info.cfp[0].data_resposta_revisao)
			v.data_limite_edicao_artigo = check_interface(v.data_limite_edicao_artigo, d_interface.info.cfp[0].data_resposta_revisao)
			v.data_decisao_final_revisor = check_interface(v.data_decisao_final_revisor, d_interface.info.cfp[0].data_decisao_final_revisor)
			v.data_final_processo = check_interface(v.data_final_processo, d_interface.info.cfp[0].data_final_processo)



		})*/

		data.info.topicos = check_interface(data.info.topicos , d_interface.info.topicos)
		data.info.convidados = check_interface(data.info.convidados , d_interface.info.convidados)
		data.info.editores = check_interface(data.info.editores , d_interface.info.editores)

		data.info.reviewers = check_interface(data.info.reviewers , d_interface.info.reviewers)
		data.info.reviewers.max_articles = check_interface(data.info.reviewers.max_articles , d_interface.info.reviewers.max_articles)
		data.info.reviewers.submit = check_interface(data.info.reviewers.submit , d_interface.info.reviewers.submit)
		data.info.reviewers.atribuition_type = check_interface(data.info.reviewers.atribuition_type , d_interface.info.reviewers.atribuition_type)
		data.info.reviewers.questions_visible_to_authors = check_interface(data.info.reviewers.questions_visible_to_authors , d_interface.info.reviewers.questions_visible_to_authors)
		data.info.reviewers.questions = check_interface(data.info.reviewers.questions , d_interface.info.reviewers.questions)

		data.info.authores = check_interface(data.info.authores , d_interface.info.authores)
		data.info.authores.max_articles = check_interface(data.info.authores.max_articles , d_interface.info.authores.max_articles)

		data.info.articles = check_interface(data.info.articles , d_interface.info.articles)
		data.info.articles.max_reviewers_article = check_interface(data.info.articles.max_reviewers_article , d_interface.info.articles.max_reviewers_article)
		data.info.articles.review_type = check_interface(data.info.articles.review_type , d_interface.info.articles.review_type)
		data.info.articles.file_type = check_interface(data.info.articles.file_type , d_interface.info.articles.file_type)
		data.info.articles.linguas = check_interface(data.info.articles.linguas , d_interface.info.articles.linguas)
		data.info.articles.template = check_interface(data.info.articles.template , d_interface.info.articles.template)

		data.profile = check_interface(data.profile, d_interface.profile)

		//console.log('RES DATA EVENTO: ', data)
		//console.log('DATA INTERFACE EVENTO: ', d_interface)

	}

	/*const fetch_id_info = async (id_serch) => {

		let list_route = api_list_route(getTokenInfo().companycode)
		//console.log(list_route)
		//return await reqGET(`${api_crud_route}/${id_serch}`)
		return await reqGET(`${list_route}/${id_serch}`)
			.then(res => {

				compareDataWithInterface(res.data[0], dados.current)

				//console.log('---------------------------> RES DATA FETCH ID INFO', res.data[0])
				//console.log('---------------------------> DADOS CURRENT', dados.current)

				set_dados(dados.current = res.data[0]);
			})
			.catch(error => error)
	}*/

	// PARA INSTANCIAR O COMPONENTE COM O ID 

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.office = getTokenInfo().office)
		//console.log(dados.current)
	}

	useEffect(() => {
		//get_topicos()
		get_editores()

		if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

		set_avaliable_file(['pdf', 'doc']);
		set_avaliable_lang([ 'Português', 'Inglês', 'Espanhol', 'Francês']);
		set_questions_visibility_author_state([language[localStorage.getItem('lang')].yes, language[localStorage.getItem('lang')].no]);

		/*const get_articles = async (id) => {

			let aArticles = [];
	
			
			return await reqGET(`${api_crud_base}/submissions/${getTokenInfo().companycode}/list`)
				.then(res => {
					//console.log(res.data)
					res.data.forEach(x => {
						let aux = { id: x.id, title: x.info.title, cfp: x.info.id_cfp, reviewers: reviewers }
	
						if(x.info.id_cfp === id){
							aArticles.push(aux);
						}
					});
					return aArticles
				})
	
				.catch(erro => { console.log(erro); alert('Erro'); })
		}*/

		clean_data();

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				//if (props.location.state !== undefined) {
				//console.log('->>>>>>>>>>>>>>>>:' + props.location.state.operation)
				//if (props.location.state.operation === 'edit') {
				set_show_vat_form('d-none')
				set_show_delete_button('')

				const fetch_id_info = async (id_serch) => {

					let list_route = api_list_route(getTokenInfo().companycode)
					//console.log(list_route)
					//return await reqGET(`${api_crud_route}/${id_serch}`)
					return await reqGET(`${list_route}/${id_serch}`)
						.then(res => {
			
							compareDataWithInterface(res.data[0], dados.current)
			
							//console.log('---------------------------> RES DATA FETCH ID INFO EVENTO', res.data[0])
							//console.log('---------------------------> DADOS CURRENT EVENTO', dados.current)
			
							set_dados(dados.current = res.data[0]);
						})
						.catch(error => error)
				}

				//console.log('AQUI DENTRO DO STATE')
				fetch_id_info(props.location.state.item['id']).then(async() => {

					//let lista_revs = await get_reviewers()
					//console.log('lista_revs->', lista_revs)
					//reviewers.current = lista_revs

					//let lista_arts = await get_articles(props.location.state.item['id'])
					//console.log('lista_arts->', lista_arts)
					//articles.current = lista_arts
					//setRefresh(refresh + 1)

					//console.log('++++++++++', articles.current)

					setLoading(false)
				})
			}
		} catch {
			// VAI REGISTAR
			set_show_vat_form('');

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps


	}, [props])


	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {
			//alert('Atualizar PUT')

			confirmAlert({
				title: language[ lang ].edit ,
				message: language[ lang ].edit_text ,
				buttons: [
					{
						label: language[ lang ].edit_confirm ,
						onClick: () => {

							reqPUT(api_crud_route, dados.current)
								.then(() => { 
									//props.history.push(endpoints.list) 

									/*files_doc.forEach(el_doc => {
										if(el_doc !== null)
											handleTemplateFileUpload(el_doc.files)
									})*/

									//console.log('handleSubmit edit', files_doc)
									if(files_doc !== null && files_doc !== undefined && files_doc.files !== undefined && files_doc.files.length > 0) {
										handleTemplateFileUpload(files_doc.files)
									}
									set_files_doc([])
									set_files_doc_name([])

								})
								.catch((error) => /*alert(language[ lang ].edit_error),*/ console.log(error))
						}
					},
					{
						label: language[ lang ].edit_cancel,
						onClick: () => { return }
					}
				]
			})
		} else {

			if(dados.current.info.cfp.length > 0) {
				confirmAlert({
					title: language[ lang ].insert_title ,
					message: language[ lang ].insert_text ,
					buttons: [
						{
							label: language[ lang ].insert_confirm ,
							onClick: () => {

								var unique_code = new Date().valueOf();

								dados.current.info.unique_code = '' + unique_code + '';

								reqPOST(api_crud_route, dados.current)
									.then(() => { 
										//props.history.push(endpoints.list) 

										if(dados.current.id === '') {
											reqGET(`${api_crud_route}/${getTokenInfo().companycode}`)
												.then(res_2 => { 
													res_2.data.forEach(v => {

														if(v.info.unique_code !== undefined && v.info.unique_code === dados.current.info.unique_code){
															set_dados(dados.current.id = v.id)
														}
													})
												})
										}

										//console.log('handleSubmit regist', files_doc)
										//files_doc.forEach(el_doc => {
										//	console.log('el_doc', el_doc)
											if(files_doc !== null) {
												handleTemplateFileUpload(files_doc.files)
											}
										//})

										set_files_doc([])
										set_files_doc_name([])

										set_is_edit(true)
										set_show_delete_button('')

									})
									.catch(() => alert( language[ lang ].insert_error ))
							}
						},
						{
							label: language[ lang ].insert_cancel ,
							onClick: () => { return }
						}
					]
				})
			} else {
				alert(language[lang].insert_event_cfp_error_message)
			}
		}
	}

	function apagar() {


		confirmAlert({
			title: language[ lang ].delete_cfp ,
			message: language[ lang ].delete_cfp_text ,
			buttons: [
				{
					label: language[ lang ].delete_cfp_confirm ,
					onClick: () => {
						
						reqDELETE(api_crud_route + '/', { id: dados.current.id })
							.then(res => {
								/* alert(res.status === 200 ?
									'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); 
								*/
								props.history.push(endpoints.list)
							})
							.catch(error => alert(error))
					}
				},
				{
					label: language[ lang ].delete_cfp_cancel ,
					onClick: () => { return }
				}
			]
		});
	};

	/*const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/financials/${getTokenInfo().companycode}`)
			.then(res => {
				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {
					confirmAlert({
						title: language[ lang ].warning ,
						message: 'Já Existe um Registo com este VAT.', // TODO:
						buttons: [
							{
								label: language[ lang ].back ,
								onClick: () => { props.history.push(endpoints.list) }
							},

						]
					})

					//console.log(ja_existe);
				}
			}
			)
	}*/

	/*const get_topicos = async () => {
		let aTopicos = [];

		reqGET(`${api_crud_base}/topic/${getTokenInfo().companycode}`)
			.then(res => {
				//console.log(res.data)

				res.data.forEach(v => {
					aTopicos.push({ label: v.info.name, value: v.id })
				});
				

				set_topicos(aTopicos)
				//console.log(aTopicos)
			})
			.catch( erro => { console.log( erro ) ; alert( language[ lang ].error ) ; } )
	}*/

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/
		/* 
				//console.log('NAME:' + name)
				//console.log('Value:' + value)
		 */
		set_dados(dados.current.info[name] = value)

		/* //console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados)) */

	}

	// Util Functions
	const select_option_util_fun = arg => {
		return( arg.map( k => ( { value : k , label : k } ) ) ) ;
	}

	const handle_change_info_articles = (e) => {
		const { name, value} = e.target;

		// console.log(name)
		// console.log(value)

		set_dados(dados.current.info.articles[name] = value)
        //console.log('Dados Current:' + JSON.stringify(dados))
	}


	const handle_change_info_reviewers = (e) => {
		const { name, value} = e.target;

		// console.log(name)
		// console.log(value)

		set_dados(dados.current.info.reviewers[name] = value)
        //console.log('Dados Current:' + JSON.stringify(dados))
	}

	/*const change_reviewers_submit = (e) => {
		const { value } = e;

		set_dados(dados.current.info.reviewers.submit = value)
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	const change_reviewers_review_type = (e) => {
		const { value } = e;

		set_dados(dados.current.info.articles.review_type = value)
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const change_reviewers_atribuition = (e) => {
		const { value } = e;

		set_dados(dados.current.info.reviewers.atribuition_type = value)
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_info_authores = (e) => {
		const { name, value} = e.target;

		set_dados(dados.current.info.authores[name] = value)
        //console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_info_convidados = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;

		set_dados(dados.current.info.convidados[index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const set_novo_convidado = (e) => {
		const { name, value } = e.target;

		if(name === 'convidado_nome')
			set_nome_convidado(value)
		if(name === 'convidado_area')
			set_area_convidado(value)
		if(name === 'convidado_instituicao')
			set_instituicao_convidado(value)
		if(name === 'convidado_descricao')
			set_descricao_convidado(value)
	}

	const add_convidado = () => {
		
		set_dados(dados.current.info.convidados.push(
			{ 
				nome: nome_convidado,
				area: area_convidado,
				instituicao: instituicao_convidado,
				descricao: descricao_convidado
			}
		));

		set_nome_convidado('')
		set_area_convidado('')
		set_instituicao_convidado('')
		set_descricao_convidado('')


		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const removeInputConvidado = (index) => {

		let del_value = dados.current.info.convidados.slice(index, index + 1);
		let convidados = dados.current.info.convidados.filter(v => v.nome !== del_value[0].nome);
		//console.log(convidados);

		set_dados(dados.current.info.convidados = convidados)
	
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	};

	/*const handle_change_novo_topico = (e) => {
		const { value } = e.target;

		set_nome_topico(value)
	}*/

	/*const handle_selected_topico = (e) => {
		const { label, value } = e;

		//console.log(label)
		//console.log(value)
		
		set_selected_topico({label: label, value: value })
	}*/

	/*const add_topico = () => {
		//console.log('add_topic')
		//console.log(topico_selected)
		
		let topico = topicos.filter(v => v.label === topico_selected.label);
		if(topico.length === 0) {
			// reqPOST(`${api_crud_base}/topic`, {id: '', info: {name: nome_topico, companycode: getTokenInfo().companycode}})
			// 	.then(() => { get_topicos() })
			// 	.catch(() => alert('Problema ao atualizar Registo!'))
		}
		else {
			set_dados(dados.current.info.topicos.push(
				{ 
					id:  topico_selected.value,
					nome: topico_selected.label
				}
			));
		}

		set_selected_topico({label: '', value: '' })
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const add_novo_topico = (e) => {
		let topico = topicos.filter(v => v.label === nome_topico);
		if(topico.length === 0) {
			reqPOST(`${api_crud_base}/topic`, {id: '', info: {name: nome_topico, companycode: getTokenInfo().companycode}})
				.then(() => { get_topicos() })
				.catch(() => alert( language[ lang ].add_topic_error ))
		}
		else {
			//console.log('2')
		}

		set_nome_topico('')
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const removeInputTopico = (index) => {

		let del_value = dados.current.info.topicos.slice(index, index + 1);
		let topicos = dados.current.info.topicos.filter(v => v.nome !== del_value[0].nome);
		//console.log(topicos);

		set_dados(dados.current.info.topicos = topicos)
	
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	};*/

	/*const handle_change_info_topico = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;

		set_dados(dados.current.info.topicos[index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	const handle_selected_editor = (e) => {
		const { label, value } = e;

		//console.log(label)
		//console.log(value)
		
		set_selected_editor({label: label, value: value })
	}

	const add_editor = () => {
		//console.log('add_topic')
		//console.log(topico_selected)
		
		let editor = editores.filter(v => v.label === editor_selected.label);
		if(editor.length === 0) {

		}
		else {
			set_dados(dados.current.info.editores.push(
				{ 
					id:  editor_selected.value,
					name: editor_selected.label
				}
			));
		}

		set_selected_editor({label: '', value: '' })
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const removeInputEditor = (index) => {

		let del_value = dados.current.info.editores.slice(index, index + 1);
		let editores = dados.current.info.editores.filter(v => v.id !== del_value[0].id);
		//console.log(editores);

		set_dados(dados.current.info.editores = editores)
	
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	};

	const handle_change_info_editor = (e) => {
		const { /*name,*/ value, dataset } = e.target;
		const { index } = dataset;

		set_dados(dados.current.info.editores[index].id = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const set_novo_cfp = (e) => {
		const { name, value } = e.target;

		if(name === 'cfp_nome')
			set_nome_cfp(value)
		if(name === 'cfp_descricao')
			set_descricao_cfp(value)
		if(name === 'cfp_data_inicio')
			set_data_inicio_cfp(value)
		if(name === 'cfp_data_submissao')
			set_data_submissao_cfp(value)
		if(name === 'cfp_data_limite_fim')
			set_data_limite_fim_cfp(value)
		if(name === 'cfp_data_material_suplementar')
			set_data_material_suplementar_cfp(value)
		if(name === 'cfp_data_resposta_revisao')
			set_data_resposta_revisao_cfp(value)
		if(name === 'cfp_data_limite_edicao')
			set_data_limite_edicao_cfp(value)
		if(name === 'cfp_data_decisao_final_revisor')
			set_data_decisao_final_revisor_cfp(value)
		if(name === 'cfp_data_final_processo')
			set_data_final_processo_cfp(value)
	}

/* 	const handle_selected_cfps = (e) => {
		const { label, value } = e;

		//console.log(label)
		//console.log(value)
		
	} */

	const add_cfp = () => {

		if(nome_cfp !== '' && descricao_cfp !== '') {
			set_dados(dados.current.info.cfp.push(
				{ 
					id: dados.current.info.cfp.length + 1,
					name: nome_cfp,
					descricao: descricao_cfp,
					data_inicio: [{
						data: data_inicio_cfp,
						estado: 'activo'
					}],
					data_submissao: [{
						data: data_submissao_cfp,
						estado: 'activo'
					}],
					data_limite_fim: [{
						data: data_limite_fim_cfp,
						estado: 'activo'
					}],
					data_marerial_suplementar: data_material_suplementar_cfp,
					data_resposta_revisao: data_resposta_revisao_cfp,
					data_limite_edicao: data_limite_edicao_cfp,
					data_decisao_final_revisor: data_decisao_final_revisor_cfp,
					data_final_processo: data_final_processo_cfp
				}
			));
		
			set_nome_cfp('')
			set_descricao_cfp('')
			set_data_inicio_cfp('')
			set_data_submissao_cfp('')
			set_data_limite_fim_cfp('')
			set_data_material_suplementar_cfp('')
			set_data_resposta_revisao_cfp('')
			set_data_limite_edicao_cfp('')
			set_data_decisao_final_revisor_cfp('')
			set_data_final_processo_cfp('')
		}
		else {
			alert( language[ lang ].insert_cfp_reqs )
		}

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const removeInputCfp = (index) => {

		let del_value = dados.current.info.cfp.slice(index, index + 1);
		//console.log('CFP a apagar: ', del_value);
		//console.log('nome do CFP a apagar: ', del_value[0].name);
		let data_inicio_cfp = del_value[0].data_inicio[del_value[0].data_inicio.length -1].data;
		let data_submissao_cfp = del_value[0].data_submissao[del_value[0].data_submissao.length -1].data;
		//console.log('last data_inicio: ', new Date(data_inicio_cfp));
		//console.log('last data_submissao: ', new Date(data_submissao_cfp));
		//console.log('data de hoje: ', new Date())

		if((new Date(data_submissao_cfp) < new Date()) && (new Date(data_inicio_cfp) < new Date())){

			let cfps = dados.current.info.cfp.filter(v => v.name !== del_value[0].name);
			//console.log('CFPs actualizada: ', cfps);

			set_dados(dados.current.info.cfp = cfps)
		
			//console.log('«««««««««««««««««««««««')
			//console.log('Dados Current:' + JSON.stringify(dados))

		} 
		else {
			alert( language[ lang ].remove_cfp )
		}

	};

	const handle_change_info_cfps = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;

		if(name === 'cfp_data_inicio') {
			dados.current.info.cfp[index].data_inicio.forEach((v) => {
				v.estado = ''
			})
			dados.current.info.cfp[index].data_inicio.push({
				data: value,
				estado: 'activo'
			})
			//set_dados(dados.current.info.cfp[index].nome = value)
		}
		else if(name === 'cfp_data_submissao') {
			dados.current.info.cfp[index].data_submissao.forEach((v) => {
				v.estado = ''
			})
			dados.current.info.cfp[index].data_submissao.push({
				data: value,
				estado: 'activo'
			})
		}
		else if(name === 'cfp_data_limite_fim') {
			dados.current.info.cfp[index].data_limite_fim.forEach((v) => {
				v.estado = ''
			})
			dados.current.info.cfp[index].data_limite_fim.push({
				data: value,
				estado: 'activo'
			})
		}
		else if(name === 'nome') {
			set_dados(dados.current.info.cfp[index].nome = value)
		}
		else if(name === 'descricao') {
			set_dados(dados.current.info.cfp[index].descricao = value)
		}

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	// ////////// ////////// ////////// ////////// ////////// //////////


	const handle_change_info_reviewers_questions = (e) => {
		const { value, dataset } = e.target;
		const { index } = dataset;

		set_dados(dados.current.info.reviewers.questions[index] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const set_nova_question = (e) => {
		const { value } = e.target;

		set_pergunta(value)
	}

	const add_question = () => {
		
		set_dados(dados.current.info.reviewers.questions.push(
			{ 
				pergunta: pergunta
			}
		));

		set_pergunta('')

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const removeInputReviewerQuestion = (index) => {

		let del_value = dados.current.info.reviewers.questions.slice(index, index + 1);
		let perguntas = dados.current.info.reviewers.questions.filter(v => v.pergunta !== del_value[0].pergunta);
		//console.log(perguntas);

		set_dados(dados.current.info.reviewers.questions = perguntas)
	
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	};


/* 	const get_reviewers = async () => {
		let aReviewers = [];

		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Revisor`)
			.then(res => {
				//console.log(res.data)

				res.data.forEach(v => {
					aReviewers.push({ label: v.name + ' ' + v.surname, value: v.id })
				});
				

				set_reviewers(aReviewers)
				console.log(aReviewers)
			})
			.catch( erro => { console.log( erro ) ; alert( 'Erro' ) ; } )
	} */

	const get_editores = async () => {
		let aEditores = [];

		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Editor`)
			.then(res => {
				//console.log(res.data)
 
				res.data.forEach(v => {
					aEditores.push({ label: v.name + ' ' + v.surname, value: v.id })
				});
				

				set_editores(aEditores)
				//console.log(aEditores)
			})
			.catch( erro => { console.log( erro ) ; /*alert( language[ lang ].error ) ;*/ } )
	}

	const handleSingleCheckLang = (e) => {
        const { value } = e.target;
        //console.log('VALUE', value)

		if(dados.current.info.articles.linguas.length === 0) {
			dados.current.info.articles.linguas.push(value)
		}
		else {
			let aux = dados.current.info.articles.linguas.filter((v) => v !== value)
			if(aux.length === dados.current.info.articles.linguas.length) {
				dados.current.info.articles.linguas.push(value)
			}
			else {
				dados.current.info.articles.linguas = aux
			}
		}

		//console.log('Dados Current:' + JSON.stringify(dados))
    }

	const handleSingleCheck_lang = value => {
		if (dados.current.info.articles.linguas.length !== 0) {
			let tmp = dados.current.info.articles.linguas.filter(k => k === value)
			return tmp.length > 0 ? true : false
		}
		else
			return false
	}

	const handleSingleCheckFiles = (e) => {
        const { value } = e.target;
        //console.log('VALUE', value)

		if(dados.current.info.articles.file_type.length === 0) {
			dados.current.info.articles.file_type.push(value)
		}
		else {
			let aux = dados.current.info.articles.file_type.filter((v) => v !== value)
			if(aux.length === dados.current.info.articles.file_type.length) {
				dados.current.info.articles.file_type.push(value)
			}
			else {
				dados.current.info.articles.file_type = aux
			}
		}

		//console.log('Dados Current:' + JSON.stringify(dados))
    }
	
	const handleSingleCheck_files = value => {
		if (dados.current.info.articles.file_type.length !== 0) {
			let tmp = dados.current.info.articles.file_type.filter(k => k === value)
			return tmp.length > 0 ? true : false
		}
		else
			return false
	}

	const handleSingleCheckQuestionsAuthors = e => {
		const { name, value } = e.target;

		set_dados(dados.current.info.reviewers[name] = value)

		//console.log('Dados Current:' + JSON.stringify(dados))

		//setRefresh(refresh + 1)
	}

	const onChangeHandlerTemplateFile = async (e) => {
        //const { name } = e.target;

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(e.target.files);

		filesArray.forEach(v => {
			let ext = v.name.substr(-3);
			let fileSize = v.size;
			//console.log(ext);
			//console.log(fileSize);
			// SIZE 10 MB = 10485760 // 5 MB = 5242880 // 2 MB = 2097152
			if((ext==="pdf" || ext==="doc" || ext==="docx") && (fileSize < 10485760)){
				storedFiles.push(v);

				let aux2 = files_doc_name
				if(aux2 === undefined)
					aux2 = []
				aux2.push({name: v.name, size: v.size})
				set_files_doc_name(aux2)

				set_dados(dados.current)
				setRefresh(refresh + 1)
			}
			else{
				alert(language[lang].upload_file_error + v.name);
			}
		});	


		let files_aux = files_doc
		files_aux = {files: storedFiles}
		set_files_doc(files_aux)

		//console.log(aux2)
		//setRefresh(refresh + 1)
		//return false

		//set_dados(dados.current)
		//setRefresh(refresh + 1)

        //handleFileBase64(e);
        //handleFileZipBase64(e);
    }

	const handleTemplateFileUpload = async (files) => {

		//console.log('handleTemplateFileUpload', files)

		//let storedFiles = [];

        //const name = event.target.name
        //let article_files = event.target.files
		//console.log('Ficheiros:', article_files)
		//let filesArray = Array.prototype.slice.call(files);
        // const formData = new FormData()
        //formData.append('id', dados.current.id)
        
		// formData.append('id_cfp', dados.current.info.id_cfp)
		// formData.append('id_evento', dados.current.info.id_evento)
		// formData.append('id_autor', getTokenInfo().id)

		/*filesArray.forEach(v => {
			let ext = v.name.substr(-3);
            let fileSize = v.size;
            //console.log(ext);
            //console.log(fileSize);
			// SIZE 10 MB = 10485760 // 5 MB = 5242880 // 2 MB = 2097152
			if((ext==="pdf" || ext==="doc" || ext==="docx") && (fileSize < 10485760)){
				storedFiles.push(v);
			}
			else{
				alert(language[ lang ].upload_file_error + v.name);
			}
		});	*/

		//setMyFiles(storedFiles)


		//console.log('ARRAY FILES : ', storedFiles)

		files.forEach(f => {

			const formData = new FormData()
			//formData.append('id_cfp', dados.current.info.id_cfp)
			formData.append('id_evento', dados.current.id)
			formData.append('unique_code', dados.current.info.unique_code)
			formData.append('companycode', dados.current.info.companycode)
			formData.append('type', 'Template')
			formData.append('files', f);

			formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/');

			reqFILE(`${Hosts.SIMCore_API}/submissions/file`, formData)
	            .then((res) => { 

					//console.log(res)
					set_dados(dados.current.info.articles.template.push(
						{ 
							name: f.name,
							type: f.type,
							size: f.size,
							path: res.data.path,
							source_name: res.data.name
						}
					));

					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => alert(language[ lang ].edit_error))

				})
		});	

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

    }

	const removeTemplateFile = file => () => {


		//console.log('file', file)
		//console.log('files_doc_name', files_doc_name)

		//const newFiles = [...myFiles]
		const newFiles = [...dados.current.info.articles.template]
		newFiles.splice(newFiles.indexOf(file), 1)
		set_dados(dados.current.info.articles.template = newFiles)

		let files_aux = files_doc_name
		files_aux = files_doc_name.filter(el => el.name !== file.name)
		set_files_doc_name(files_aux)
		setRefresh(refresh + 1)

		if(files_doc.files !== undefined) {
			let files_aux_2 = files_doc
			files_aux_2.files = files_doc.files.filter(el => el.name !== file.name)
			set_files_doc(files_aux_2)
			setRefresh(refresh + 1)
		}

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
		//setMyFiles(newFiles)
	}
	
	const removeAllTemplateFiles = () => {
		set_dados(dados.current.info.articles.template = [])

		set_files_doc_name([])
		set_files_doc(null)
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
		//setMyFiles([])
	}

    /*const handleFileUpload = event => {
        const files = event.target.files
        const formData = new FormData()
        formData.append('evento', dados.current.info.id)
        formData.append('files', files[0])

        reqFILE(`${api_crud_base}/registration/file`, formData)
            .then((res) => { 

                dados.current.info.article.template.name = res.data.name
                dados.current.info.article.template.link = res.data.path
                dados.current.info.article.template.ext = res.data.ext

                //setRefresh(refresh + 1)

                console.log('sucesso POST File')

            })
            .catch(erro => console.log('Erro POST File: ' + erro))
    }*/

	// ////////// ////////// ////////// ////////// ////////// //////////

	return isloading ?
		<main>
			<div className={`dash-cards-2 header`}>
				<h2 className="dash-title">LOADING</h2>
				<p>{ language[ lang ].loading }</p>
				<div className="overlay">
					<div className="overlay__inner">
						<div className="overlay__content"><span className="spinner"></span></div>
					</div>
				</div>
			</div>
		</main>
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards-2 header`}>
					<h2 className="dash-title">{language[lang].events}</h2>
					<p>{language[lang].home} / {language[lang].events} / {language[lang].insert_event}</p>
				</div>

				<div className={`dash-cards-2 body`}>
					<div className="card">
						<div className="card-body">
													
							<form id="form" onSubmit={handleSubmit} className="assec-w-100">
								<input type="hidden" name="id" value={dados.current.id} />

								<h2 className="dash-title">{ language[ lang ].events_data }</h2>

								<div className="form-group">
									<span className="flex-2">
										<label>{language[lang].name}</label>
										<input type="text" name="name" value={dados.current.info.name} className="input-form" pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" placeholder={language[ lang ].name_placeholder}  onChange={handle_change_info} required />
									</span>

									<span className={'flex-1'}>
										<label>{language[lang].type}</label>
										<Select
											//className="div-select"
											className="assec-w-100 assec-mb-15"
											options={ select_option_util_fun( [ language[ lang ].conference , language[ lang ].magazine ] ) }
											name="tipo"
											value={dados.current.info.tipo === '' ? null : { label: dados.current.info.tipo, value: dados.current.info.tipo }}
											placeholder={ language[ lang ].type_placeholder }
											onChange={change_tipo}
											styles={custom_select_styles}
										/>
									</span>
								</div>

								<div className="form-group assec-mb-15">
									<span className="flex-2 assec-mb-15">
										<label>{ language[ lang ].description }</label>
										<textarea name="description" value={dados.current.info.description} className="input-form" rows="4" onChange={handle_change_info} required>
										</textarea>
									</span>
								</div>

								<div className="div-group">
									<Accordion
										allowZeroExpanded
										allowMultipleExpanded
										//onChange={change_accordion}
										preExpanded={is_edit === true ? [] : ['0']}
									>
										<AccordionItem uuid='0'>
											<AccordionItemHeading>
												<AccordionItemButton>
													Call for Papers
												</AccordionItemButton>
											</AccordionItemHeading>

											<AccordionItemPanel>
												<div className="div-accordion flex-1">
													<div className="form-group">
														<span className="flex-2">
															<h4>{ language[ lang ].add_new_cfp }</h4>
															<label className="assec-mt-15">{language[lang].name}</label>
															<input type="text" name="cfp_nome" value={nome_cfp} className="input-form" pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" placeholder={ language[ lang ].add_new_cfp_name_placeholder } onChange={set_novo_cfp} /*required={is_edit === true ? false : true}*/ />
														</span>
														<span className="flex-1">
														</span>
													</div>
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].description }</label>
															<textarea type="text" name="cfp_descricao" value={descricao_cfp} className="input-form" rows="4" placeholder={ language[ lang ].add_new_cfp_description_placeholder } onChange={set_novo_cfp} /*required={is_edit === true ? false : true}*/ >
															</textarea>
														</span>
													</div>
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].add_new_cfp_start_date }</label>
															<input type="date" name="cfp_data_inicio" value={data_inicio_cfp} className="input-form" placeholder={ language[ lang ].add_new_cfp_start_date_placeholder} onChange={set_novo_cfp} /*required={is_edit === true ? false : true}*/ />
														</span>

														<span className="flex-1">
															<label>{ language[ lang ].add_new_cfp_submission_date }</label>
															<input type="date" name="cfp_data_submissao" value={data_submissao_cfp} className="input-form" placeholder={ language[ lang ].add_new_cfp_submission_date_placeholder } onChange={set_novo_cfp} /*required={is_edit === true ? false : true}*/ />
														</span>

														<span className="flex-1">
															<label>{ language[ lang ].add_new_cfp_end_date }</label>
															<input type="date" name="cfp_data_limite_fim" value={data_limite_fim_cfp} className="input-form" placeholder={ language[ lang ].add_new_cfp_end_date_placeholder } onChange={set_novo_cfp} /*required={is_edit === true ? false : true}*/ />
														</span>
													</div>
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].add_new_cfp_sup_mat_deliv_date }</label>
															<input type="date" name="cfp_data_material_suplementar" value={data_material_suplementar_cfp} className="input-form" placeholder={ language[ lang ].add_new_cfp_sup_mat_deliv_date_placeholder } onChange={set_novo_cfp} />
														</span>

														<span className="flex-1">
															<label>{ language[ lang ].add_new_cfp_rev_resp_date }</label>
															<input type="date" name="cfp_data_resposta_revisao" value={data_resposta_revisao_cfp} className="input-form" placeholder={ language[ lang ].add_new_cfp_rev_resp_date_placeholder } onChange={set_novo_cfp} />
														</span>

														<span className="flex-1">
															<label>{ language[ lang ].add_new_cfp_article_edit_deadline }</label>
															<input type="date" name="cfp_data_limite_edicao" value={data_limite_edicao_cfp} className="input-form" placeholder={ language[ lang ].add_new_cfp_article_edit_deadline_placeholder } onChange={set_novo_cfp} />
														</span>
													</div>

													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].add_new_cfp_rev_fin_dec_date }</label>
															<input type="date" name="cfp_data_decisao_final_revisor" value={data_decisao_final_revisor_cfp} className="input-form" placeholder={ language[ lang ].add_new_cfp_rev_fin_dec_date_placeholder } onChange={set_novo_cfp} />
														</span>

														<span className="flex-1">
															<label>{ language[ lang ].add_new_cfp_process_end_date }</label>
															<input type="date" name="cfp_data_final_processo" value={data_final_processo_cfp} className="input-form" placeholder={ language[ lang ].add_new_cfp_process_end_date_placeholder } onChange={set_novo_cfp} />
														</span>

														<span className="flex-1">
														</span>
													</div>
													<div className="form-group assec-text-right">
														<span className="flex-1">
															<label className="dash-p-title assec-font-weight-normal assec-pb-10">{ language[ lang ].add_new_cfp_text }</label>
															<span className="button" onClick={add_cfp}>
																<img className="assec-mr-15" alt='' src={'./img/plus.svg'} />
																{ language[ lang ].add_cfp }
															</span>	
														</span>
													</div>
													<div className={dados.current.info.cfp.length > 0 ? 'assec-mt-15' : 'd-none'}>
														<h2 className="dash-title">Call for Papers</h2>
														{
														dados.current.info.cfp.map((elem, index) => {
															if(elem.name === '')
																return ''
															else {
																let aux_data_inicio = elem.data_inicio.filter((v) => v.estado = 'activo').pop()
																let aux_data_submissao = elem.data_submissao.filter((v) => v.estado = 'activo').pop()
																let aux_data_limite_fim = elem.data_limite_fim.filter((v) => v.estado = 'activo').pop()
																
																return(
																	<div key={ `${index}` } className="assec-mb-15" >
																		<div className="form-group">
																			<span className="flex-1 assec-mt-15">
																				<label>{ language[ lang ].name }</label>
																				<input
																					type="text" 
																					name ="nome"  
																					value = { elem.name } 
																					data-index = { index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																			</span>
																		</div>
																		<div className="form-group">
																			<span className="flex-1">
																				<label>{ language[ lang ].description }</label>
																				<textarea
																					type="text" 
																					name ="descricao"  
																					rows = "4"
																					value = { elem.descricao } 
																					data-index = { index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																		</div>
																		<div className="form-group">
																			<span className="flex-1">
																				<label>{ language[ lang ].start_date}</label>
																				<input
																					type="date" 
																					name="cfp_data_inicio"  
																					value={ aux_data_inicio.data } 
																					data-index={ index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<label>{ language[ lang ].submission_date }</label>
																				<input
																					type="date" 
																					name="cfp_data_submissao"  
																					value={ aux_data_submissao.data } 
																					data-index={ index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<label>{ language[ lang ].end_date }</label>
																				<input
																					type="date" 
																					name="cfp_data_limite_fim"  
																					value={ aux_data_limite_fim.data } 
																					data-index={ index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																		</div>
																		<div className="form-group">
																			<span className="flex-1">
																				<label>{ language[ lang ].sup_mat_deliv_date }</label>
																				<input
																					type="text" 
																					name="data_entrega_material_suplementar"  
																					value={ elem.data_marerial_suplementar } 
																					data-index={ index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<label>{ language[ lang ].rev_resp_date }</label>
																				<input
																					type="text" 
																					name="data_resposta_revisao"  
																					value={ elem.data_resposta_revisao } 
																					data-index={ index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<label>{ language[ lang ].article_edit_deadline }</label>
																				<input
																					type="date" 
																					name="data_limite_edicao_artigo"  
																					value={ elem.data_limite_edicao } 
																					data-index={ index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																		</div>
																		<div className="form-group assec-mb-15">
																			<span className="flex-1 assec-mb-15">
																				<label>{ language[ lang ].rev_fin_dec_date }</label>
																				<input
																					type="text" 
																					name="data_decisao_final_revisor"  
																					value={ elem.data_decisao_final_revisor } 
																					data-index={ index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<label>{ language[ lang ].process_end_date }</label>
																				<input
																					type="text" 
																					name="data_final_processo"  
																					value={ elem.data_final_processo } 
																					data-index={ index } 
																					onChange={handle_change_info_cfps} 
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																			</span>
																		</div>
																		<div className="form-group assec-text-right">
																			<span className="flex-1">
																				<span className="button-delete text-right" onClick = {() => removeInputCfp(index) }>
																					<img className="assec-mr-15" alt='' src={'./img/remove.svg'} />
																					{language[lang].remove} {elem.nome}
																				</span>
																			</span>
																		</div>
																	</div>
																)
															}
														})											
														}
													</div>
												</div>
											</AccordionItemPanel>
										</AccordionItem>
										{ /*
										<AccordionItem uuid='1'>
											<AccordionItemHeading>
												<AccordionItemButton>
													{ language[ lang ].topics }
												</AccordionItemButton>
											</AccordionItemHeading>

											<AccordionItemPanel>
												<div className="div-accordion flex-1">
													<div className="form-group">
														<div className="flex-1">
															<div className="form-group">
																<span className="flex-2">
																	<label>{ language[ lang ].topic }</label>
																	<Select
																		options={topicos}
																		name="topico"
																		placeholder={"Introduza o topico"}
																		value={topico_selected}
																		onChange={handle_selected_topico}
																		styles={custom_select_styles}
																	/>
																</span>
																<span className="flex-1">
																	<label>&nbsp;</label>
																	<button type="button" className="button assec-m-0" onClick={add_topico}>
																		<img className="assec-mr-15" alt='' src={'./img/plus.svg'} />
																		{ language[ lang ].add_topic }
																	</button>	
																</span>
															</div>
														</div>
														<div className="flex-1">
															<div className="form-group">
																<span className="flex-2">
																	<label>{ language[ lang ].new_topic }</label>
																	<input 
																		type="text" 
																		name="topico_nome" 
																		value={nome_topico} 
																		className="input-form" 
																		pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" 
																		placeholder="Introduza o nome do tópico" 
																		onChange={handle_change_novo_topico} 
																	/>
																</span>
																<span className="flex-1">
																	<label>&nbsp;</label>
																	<button type="button" className="button assec-m-0" onClick={add_novo_topico}>
																		<img className="assec-mr-15" alt='' src={'./img/plus.svg'} />
																		{ language[ lang ].add_new }
																	</button>	
																</span>
															</div>
														</div>
													</div>
													<div className="form-group">
													</div>
													<div className={dados.current.info.topicos.length > 0 ? 'assec-mt-15' : 'd-none'}>
														<h2 className="dash-title">{ language[ lang ].topics }</h2>
														{
														dados.current.info.topicos.map( ( elem , index ) => {
															if(elem.nome === '')
																return ''
															else
																return(
																	<div key={`${index}`} className="assec-mb-15">
																		<div className="form-group">
																			<span className="flex-2">
																				<label>{ language[ lang ].topic }</label>
																				<input
																					type="text"
																					name="nome"
																					value={elem.nome}
																					data-index={index}
																					onChange={handle_change_info_topico}
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<label>&nbsp;</label>
																				<button type="button" className="button assec-m-0" onClick = {() => removeInputTopico(index) }>
																					<img className="assec-mr-15" alt='' src={'./img/remove.svg'} />
																					{language[lang].remove}
																				</button>
																			</span>
																		</div>
																		
																	</div>
																)
														})											
														}
													</div>
												</div>
											</AccordionItemPanel>
										</AccordionItem>
										*/ }

										<AccordionItem uuid='2'>
											<AccordionItemHeading>
												<AccordionItemButton>
													{ language[ lang ].publishers }
												</AccordionItemButton>
											</AccordionItemHeading>

											<AccordionItemPanel>
												<div className="div-accordion flex-1">
													<div className="form-group">
														<div className="flex-1">
															<div className="form-group">
																<span className="flex-2">
																	<label>{ language[ lang ].publisher }</label>
																	<Select
																		options={editores}
																		name="editor"
																		placeholder={"Introduza o editor"} // TODO:
																		value={editor_selected}
																		onChange={handle_selected_editor}
																		styles={custom_select_styles}
																	/>
																</span>
																<span className="flex-1">
																	<label>&nbsp;</label>
																	<button type="button" className="button assec-m-0" onClick={add_editor}>
																		<img className="assec-mr-15" alt='' src={'./img/plus.svg'} />
																		{ language[ lang ].add_publisher }
																	</button>	
																</span>
															</div>
														</div>
													</div>
													<div className="form-group">
													</div>
													<div className={dados.current.info.editores.length > 0 ? 'assec-mt-15' : 'd-none'}>
														<h2 className="dash-title">{ language[ lang ].publishers }</h2>
														{
														dados.current.info.editores.map( ( elem , index ) => {
															if(elem.nome === '')
																return ''
															else
																return(
																	<div key={`${index}`} className="assec-mb-15">
																		<div className="form-group">
																			<span className="flex-2">
																				<label>{ language[ lang ].publisher }</label>
																				<input
																					type="text"
																					name="nome"
																					value={elem.name}
																					data-index={index}
																					onChange={handle_change_info_editor}
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<label>&nbsp;</label>
																				<button type="button" className="button assec-m-0 button-delete" onClick = {() => removeInputEditor(index) }>
																					<img className="assec-mr-15" alt='' src={'./img/remove.svg'} />
																					{ language[ lang ].remove_publisher }
																				</button>
																			</span>
																		</div>
																		
																	</div>
																)
														})											
														}
													</div>
												</div>
											</AccordionItemPanel>
										</AccordionItem>

										<AccordionItem uuid='3'>
											<AccordionItemHeading>
												<AccordionItemButton>
													{ language[ lang ].guests }
												</AccordionItemButton>
											</AccordionItemHeading>

											<AccordionItemPanel>
												<div className="div-accordion flex-1">
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].guest_name }</label>
															<input type="text" name="convidado_nome" value={nome_convidado} className="input-form" pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" placeholder={ language[ lang ].guest_name_placeholder } onChange={set_novo_convidado} />
														</span>
														<span className="flex-1">
															<label>{ language[ lang ].guest_area }</label>
															<input type="text" name="convidado_area" value={area_convidado} className="input-form" pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" placeholder={ language[ lang ].guest_area_placeholder } onChange={set_novo_convidado} />
														</span>
														<span className="flex-1">
															<label>{ language[ lang ].guest_affiliation }</label>
															<input type="text" name="convidado_instituicao" value={instituicao_convidado} className="input-form" pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" placeholder={ language[ lang ].guest_affiliation_placeholder } onChange={set_novo_convidado} />
														</span>
													</div>
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].guest_description }</label>
															<textarea type="text" name="convidado_descricao" rows="4" value={descricao_convidado} className="input-form" placeholder={ language[ lang ].guest_description_placeholder } onChange={set_novo_convidado} />
														</span>
													</div>
													<div className="form-group assec-text-right">
														<span className="flex-1">
															<span className="button" onClick={add_convidado}>
																<img className="assec-mr-15" alt='' src={'./img/plus.svg'} />
																{ language[ lang ].add_guest }
															</span>	
														</span>
													</div>
													<div className={dados.current.info.convidados.length > 0 ? 'assec-mt-15' : 'd-none'}>
														<h2 className="dash-title">{ language[ lang ].guests }</h2>
														{
														dados.current.info.convidados.map( ( elem , index ) => {
															if(elem.nome === '')
																return ''
															else
																return(
																	<div key={ `${index}` } className="assec-mb-15" >
																		<div className="form-group">
																			<span className="flex-1">
																				<label>{ language[ lang ].guest_name }</label>
																				<input
																					type="text" 
																					name ="nome"  
																					value = { elem.nome } 
																					data-index = { index } 
																					onChange={handle_change_info_convidados} 
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<label>{ language[ lang ].guest_area }</label>
																				<input 
																					type="text" 
																					name ="area"  
																					value = { elem.area } 
																					data-index = { index } 
																					onChange={handle_change_info_convidados} 
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<label>{ language[ lang ].guest_affiliation }</label>
																				<input 
																					type="text" 
																					name ="instituicao"  
																					value = { elem.instituicao } 
																					data-index = { index } 
																					onChange={handle_change_info_convidados} 
																					readOnly
																				/>
																			</span>
																		</div>
																		<div className="form-group">
																			<span className="flex-1">
																				<label>{ language[ lang ].guest_description }</label>
																				<textarea 
																					type="text" 
																					name="descricao" 
																					rows="4"
																					value={elem.descricao} 
																					data-index = { index } 
																					placeholder={ language[ lang ].guest_description_placeholder } 
																					onChange={handle_change_info_convidados} 
																					readOnly
																				/>
																			</span>
																		</div>
																		<span className="assec-mb-15">
																			<span className="button" onClick = {() => removeInputConvidado(index) }>
																				<img className="assec-mr-15" alt='' src={'./img/remove.svg'} />
																				{language[lang].remove} {elem.nome}
																			</span>
																		</span>
																	</div>
																)
														})											
														}
													</div>
												</div>
											</AccordionItemPanel>
										</AccordionItem>

										<AccordionItem uuid='4'>
											<AccordionItemHeading>
												<AccordionItemButton>
													{ language[ lang ].reviewers }
												</AccordionItemButton>
											</AccordionItemHeading>

											<AccordionItemPanel>
												<div className="div-accordion flex-1">
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].max_numb_art_reviewer }</label>
															<input type="text" name="max_articles" value={dados.current.info.reviewers.max_articles} className="input-form" pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" placeholder={ language[ lang ].max_numb_art_reviewer_placeholder } onChange={handle_change_info_reviewers}/>
														</span>
														{/*
														<span className="flex-1">
															<label>{ language[ lang ].can_submit_article }</label>
															<Select
																className="assec-w-100 assec-mb-15"
																options={ select_option_util_fun( [ language[ lang ].yes , language[ lang ].no ] ) }
																name="submit"
																value={dados.current.info.reviewers.submit === '' ? null : { label: dados.current.info.reviewers.submit, value: dados.current.info.reviewers.submit }}
																placeholder={ language[ lang ].insert_option }
																onChange={change_reviewers_submit}
																styles={custom_select_styles}
															/>
														</span>
														*/ }
														<span className="flex-1">
															<label>{ language[ lang ].reviewer_attrib_method }</label>
															<Select
																className="assec-w-100 assec-mb-15"
																options={ select_option_util_fun( [ language[ lang ].manual /*, language[ lang ].automatic_method */ ] ) }
																name="submit"
																value={dados.current.info.reviewers.atribuition_type === '' ? null : { label: dados.current.info.reviewers.atribuition_type, value: dados.current.info.reviewers.atribuition_type }}
																placeholder={ language[ lang ].insert_option }
																onChange={change_reviewers_atribuition}
																styles={custom_select_styles}
															/>
														</span>														
													</div>

													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].author_question_authorization}</label>
															{/*<span className="div-checkbox-group">
																{
																questions_visibility_author_state.map((value, key) => {
																	
																	return (
																		<label key={key} className="div-checkbox">
																			{value}
																			<input
																				name="questions_visible_to_authors"
																				//className="checkbox-form"
																				type="radio"
																				value={dados.current.info.reviewers.questions_visible_to_authors === true ? true : false}
																				onChange={handleSingleCheckQuestionsAuthors}
																				defaultChecked={true}
																			/>
																			<span className="checkmark"></span>
																		</label>
																	)
																})
																}
															</span>
															*/}
															<span className="div-checkbox-group">
																{
																questions_visibility_author_state.map((elem, key) => {
																	
																	return (
																			<label key={key} className="div-checkbox">
																				{elem}
																				<input
																					type="radio"
																					name="questions_visible_to_authors"
																					value={elem === language[lang].yes ? true : false}
																					defaultChecked = {((elem === language[lang].yes && dados.current.info.reviewers.questions_visible_to_authors === "true") || (elem === language[lang].no && dados.current.info.reviewers.questions_visible_to_authors === "false")) ? true : false }
																					onChange={ handleSingleCheckQuestionsAuthors } 
																				/>
																				<span className="checkmark"></span>
																			</label>
																		)
																	})
																}
															</span>
														</span>
													</div>
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].new_question }</label>
															<textarea type="text" name="pergunta" value={pergunta} className="input-form" placeholder={ language[ lang ].new_question_placeholder } onChange={set_nova_question} />
														</span>
													</div>
													<div className="form-group assec-text-right">
														<span className="flex-1">
															<i className="fa fa-plus" aria-hidden="true"></i>
															<span className="button" onClick={add_question}>
																<img className="assec-mr-15" alt='' src={'./img/plus.svg'} />
																{ language[ lang ].add_question }
															</span>	
														</span>
													</div>
													<div className={dados.current.info.reviewers.questions.length > 0 ? 'assec-mt-15' : 'd-none'}>
														<h2 className="dash-title">{ language[ lang ].questions }</h2>
														{
														dados.current.info.reviewers.questions.map( ( elem , index ) => {
															if(elem.pergunta === '') {
																return ''
															
															}
															else {
																return(
																	<div key={ `${index}` } className="assec-mb-15" >
																		<div className="form-group">
																			<span className="flex-1">
																				<label>{ language[ lang ].question } {index + 1}</label>
																				<textarea 
																					type="text" 
																					name="pergunta" 
																					value={elem.pergunta} 
																					data-index = { index } 
																					placeholder={ language[ lang ].insert_question }
																					onChange={handle_change_info_reviewers_questions} 
																					readOnly
																				/>
																			</span>
																		</div>
																		<span className="assec-mb-15">
																			<span className="button" onClick = {() => removeInputReviewerQuestion(index) }>
																				{ language[ lang ].remove }
																			</span>
																		</span>
																	</div>
																)
															}
														})											
														} 
													</div>
												</div>
											</AccordionItemPanel>
										</AccordionItem>

										<AccordionItem uuid='5'>
											<AccordionItemHeading>
												<AccordionItemButton>
													{ language[ lang ].authors }
												</AccordionItemButton>
											</AccordionItemHeading>

											<AccordionItemPanel>
												<div className="div-accordion flex-1">
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].max_numb_art_author }</label>
															<input type="text" name="max_articles" value={dados.current.info.authores.max_articles} className="input-form" pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" placeholder={ language[ lang ].max_numb_art_author_placeholder } onChange={handle_change_info_authores} required />
														</span>
														<span className="flex-2"></span>
													</div>
													{/*
													<div className={dados.current.info.authores.list.length > 0 ? 'assec-mt-15' : 'd-none'}>
														<h2 className="dash-title">{ language[ lang ].authors }</h2>
														{
														dados.current.info.authores.list.map( ( elem , index ) => {
															if(elem.nome === '')
																return ''
															else
																return(
																	<div key={`${index}`} className="assec-mb-15">
																		<div className="form-group">
																			<span className="flex-2">
																				<label>{ language[ lang ].author }</label>
																				<input
																					type="text"
																					name="nome"
																					value={elem.name}
																					data-index={index}
																					onChange={handle_change_info_editor}
																					readOnly
																				/>
																			</span>
																			<span className="flex-1">
																				<span className="button" onClick = {() => removeInputEditor(index) }>
																					<img className="assec-mr-15" alt='' src={'./img/remove.svg'} />
																					{ language[ lang ].remove_publisher }
																				</span>
																			</span>
																		</div>
																		
																	</div>
																)
														})											
														}
													</div>
													*/}
												</div>
											</AccordionItemPanel>
										</AccordionItem>

										<AccordionItem uuid='6'>
											<AccordionItemHeading>
												<AccordionItemButton>
													{ language[ lang ].articles }
												</AccordionItemButton>
											</AccordionItemHeading>

											<AccordionItemPanel>
												<div className="div-accordion flex-1">
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].max_numb_rev_per_art }</label>
															<input type="text" name="max_reviewers_article" value={dados.current.info.articles.max_reviewers_article} className="input-form" pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" placeholder={ language[ lang ].max_numb_rev_per_art_placeholder } onChange={handle_change_info_articles} />
														</span>
														<span className="flex-1">
															<label>{ language[ lang ].review_type }</label>
															<Select 
																className="assec-w-100 assec-mb-15"
																options={ select_option_util_fun( [ 'Double-Blind', 'Single-Blind', language[ lang ].unrestricted ] ) }
																name="review_type"
																value={dados.current.info.articles.review_type === '' ? null : { label: dados.current.info.articles.review_type, value: dados.current.info.articles.review_type }}
																placeholder={ language[ lang ].insert_option }
																onChange={change_reviewers_review_type}
																styles={custom_select_styles}
															/>
														</span>
													</div>
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].template }</label>
															<label>{ language[ lang ].add_files }</label>
															<div className="assec-w-100">
																<label className="assec-dropzone assec-font-weight-normal" htmlFor="input_template_file">{ language[ lang ].add_files_placeholder }</label>
																<input
																	id="input_template_file"
																	className="assec-d-none"
																	name="template[]"
																	type="file"
																	multiple
																	accept=".pdf,.doc,.docx"
																	onChange={onChangeHandlerTemplateFile}
																/>
																<aside>
																	{dados.current.info.articles.template.length > 0 && <label>{ language[ lang ].files }</label>}
																	<ul>
																		{dados.current.info.articles.template.map(file => (
																			<li key={file.name}>        
																				{file.name} - {file.size} bytes{" "}
																				
																				<button type="button" className="upload-button" title={ language[ lang ].remove_file } alt={ language[ lang ].remove_file } onClick={removeTemplateFile(file)}>X</button>
																				{/* <br></br>
																				<button className="upload-button" onClick={onFileUpload}>Upload!</button> */}
																			</li>
																		))}

																		{files_doc_name !== undefined && files_doc_name !== null ?	
																			files_doc_name.map((file, k) => {
																				return (
																					<li key={k}>        
																						{file.name} - {file.size} bytes{" "}
																						
																						<button type="button" className="upload-button" title={language[lang].remove_file} alt={language[lang].remove_file} onClick={removeTemplateFile(file)}>X</button>
																						{/* <br></br>
																						<button className="upload-button" onClick={onFileUpload}>Upload!</button> */}
																					</li>
																				)
																			})
																		:
																			''
																		}
																	</ul>
																</aside>
																
																{(dados.current.info.articles.template.length > 1 || (files_doc_name !== undefined && files_doc_name.length > 1)) && <button type="button" className="upload-button" title={ language[ lang ].remove_all } alt={ language[ lang ].remove_all } onClick={removeAllTemplateFiles}>{ language[ lang ].remove_all }</button>}
															</div>
														</span>
													</div>
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].accepted_languages}</label>
															<span className="div-checkbox-group">
																{
																avaliable_lang.map((value, key) => {
																	return (
																		<label key={key} className="div-checkbox">
																			{value}
																			<input
																				name={value}
																				className="checkbox-form"
																				type="checkbox"
																				value={value}
																				onChange={handleSingleCheckLang}
																				defaultChecked={handleSingleCheck_lang(value)}
																			/>
																			<span className="checkmark"></span>
																		</label>
																	)
																})
																}
															</span>
														</span>
													</div>
													<div className="form-group">
														<span className="flex-1">
															<label>{ language[ lang ].file_types }</label>
															<span className="div-checkbox-group">
																{
																avaliable_file.map((value, key) => {
																	return (
																		<label key={key} className="div-checkbox">
																			{value}
																			<input
																				name={value}
																				className="checkbox-form"
																				type="checkbox"
																				value={value}
																				onChange={handleSingleCheckFiles}
																				defaultChecked={handleSingleCheck_files(value)}
																			/>
																			<span className="checkmark"></span>
																		</label>
																	)
																})
																}
															</span>
														</span>
													</div>

													{/*
													<div className={dados.current.info.articles.list.length > 0 ? 'assec-mt-15' : 'd-none'}>
														<h2 className="dash-title">{ language[ lang ].authors }</h2>
														{
														dados.current.info.articles.list.map( ( elem , index ) => {
															if(elem.nome === '')
																return ''
															else
																return(
																	<div key={`${index}`} className="assec-mb-15">
																		<div className="form-group">
																			<span className="flex-2">
																				<label>{ language[ lang ].article }</label>
																				<input
																					type="text"
																					name="nome"
																					value={elem.name}
																					data-index={index}
																					readOnly
																				/>
																			</span>
																		</div>
																		
																	</div>
																)
														})											
														}
													</div>
													*/}
												</div>
											</AccordionItemPanel>
										</AccordionItem>
									</Accordion>
								</div>
							</form>
						</div>
					</div>
				</div>

				<div className={'dash-cards-2 footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{ language[ lang ].cancel }</span>
									</Link>
								</li>

								<li className={"nav-item " + show_delete_button}>
									<button onClick={apagar} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{ language[ lang ].delete }</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{ language[ lang ].save }</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
